export const defaultDarkTextColor = "#000000FF"
export const defaultLightTextColor = "#FFFFFFFF"
